var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDangerRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_63",
    "data-name": "Exclusion 63",
    d: "M9689-5083a12.915,12.915,0,0,1-9.193-3.808A12.913,12.913,0,0,1,9676-5096a12.911,12.911,0,0,1,3.807-9.192A12.915,12.915,0,0,1,9689-5109a12.917,12.917,0,0,1,9.192,3.808A12.917,12.917,0,0,1,9702-5096a12.919,12.919,0,0,1-3.808,9.192A12.917,12.917,0,0,1,9689-5083Zm-.1-9.318a1.757,1.757,0,0,0-1.807,1.743,1.766,1.766,0,0,0,1.807,1.763,1.776,1.776,0,0,0,1.826-1.763A1.767,1.767,0,0,0,9688.9-5092.318Zm.02-11.257a1.713,1.713,0,0,0-1.224.521,1.2,1.2,0,0,0-.352.887l.336,7.811a1.2,1.2,0,0,0,1.239,1.093,1.185,1.185,0,0,0,1.239-1.093l.336-7.811a1.148,1.148,0,0,0-.32-.888A1.724,1.724,0,0,0,9688.917-5103.575Z",
    transform: "translate(-9676 5109)",
    fill: "#ff8d73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerRed);
export default __webpack_public_path__ + "static/media/danger-red.70489cc7c65c14b67199a7a93ecec326.svg";
export { ForwardRef as ReactComponent };